import { defineComponent as _defineComponent } from 'vue'
import {reactive, ref} from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'OtpComponent',
  props: {
  default: String,
  digitCount: {
    type: Number,
    required: true
  }
},
  emits: ['update:otp'],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

const props = __props;

const digits = reactive<[string | null]>([null]);
if (props.default && props.default.length === props.digitCount) {
  for (let i =0; i < props.digitCount; i++) {
    digits[i] = props.default.charAt(i);
  }
} else {
  for (let i =0; i < props.digitCount; i++) {
    digits[i] = null;
  }
}
const otpCont = ref();
const emit = __emit;
const isDigitsFull = function () {
  for (const elem of digits) {
    if (elem == null || elem == undefined) {
      return false;
    }
  }
  return true;
};
const handleKeyDown = function (event: any, index: number) {
  if (event.key !== "Tab" &&
    event.key !== "ArrowRight" &&
    event.key !== "ArrowLeft" &&
    !(event.key == 'v' && event.ctrlKey)
  ) {
    event.preventDefault();
  }

  if (event.key === "Backspace") {
    digits[index] = null;

    if (index != 0) {
      (otpCont.value.children)[index-1].focus();
    }
    return;
  }
  if ((new RegExp('^[a-zA-Z0-9]$')).test(event.key)) {
    digits[index] = event.key;
    if (index != props.digitCount - 1) {
      (otpCont.value.children)[index+1].focus();
    }
    if (isDigitsFull()) {
      emit('update:otp', digits.join(''));
    }
  }
};
const handlePaste = (event: any, index: number) => {
  const code: string = event.clipboardData.getData('text');

  for (let i =0; i < props.digitCount; i++) {
    digits[i] = code.charAt(i);
  }
  emit('update:otp', digits.join(''));
};

const __returned__ = { props, digits, otpCont, emit, isDigitsFull, handleKeyDown, handlePaste }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})